module.exports = __webpack_public_path__ + "static/media/qrCode.82569bfb.png";